import { useState, useEffect, useContext } from 'react';
import { LangContext } from '../../context/LangContext';
import './style.css';

function Cookies() {
    const [visible, setVisible] = useState(false);
    const { translations } = useContext(LangContext);

    useEffect(() => {
        const cookiesStorage = localStorage.getItem('cookies_vanrah');
        if (!cookiesStorage) setVisible(true);
    }, []);

    const cookiesRead = () => {
        localStorage.setItem('cookies_vanrah', '1');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-bar">
            <p>{translations.cookies_msg}</p>
            <button onClick={cookiesRead}>{translations.cookies_btn}</button>
        </div>
    );
}

export default Cookies;